export default "__VITE_ASSET__RgkzEA5E__"